import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { TextButton } from 'seagull';
import { getURLWithFullPageInvoice } from '~/components/FullPageInvoice/FullPageInvoice.utils';
import { anyDeliveryIsApprovalRequest, formatRecipient, groupRecipients, joinChannelLabels, joinChannelVerbs } from './notificationHeadlines.utils';
export { formatRecipient };
const INVOICE_LINK_TOKEN = '[invoiceLink]';
const invoiceLinkNode = (entry)=>{
    const invoiceData = entry.invoiceData();
    if (!invoiceData) return '';
    const { invoiceId, invoiceNumber, relationshipId } = invoiceData;
    return /*#__PURE__*/ _jsx(TextButton, {
        bi: {
            name: 'open_invoice_from_activity_log_notification'
        },
        as: Link,
        to: getURLWithFullPageInvoice({
            invoiceId,
            relationshipId
        }),
        underline: "none",
        children: invoiceNumber
    });
};
const composeWithInvoiceLink = (entry, render)=>{
    const text = render(INVOICE_LINK_TOKEN);
    const parts = text.split(INVOICE_LINK_TOKEN);
    if (parts.length === 1) {
        return text;
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: parts.map((segment, index)=>/*#__PURE__*/ _jsxs(Fragment, {
                children: [
                    segment,
                    index < parts.length - 1 ? invoiceLinkNode(entry) : null
                ]
            }, index))
    });
};
export const NOTIFICATION_HEADLINES = {
    RelationshipApprovedCustomer: (_entry, deliveries, t)=>t.activityLog.notif.relationshipApproved({
            channelVerb: joinChannelVerbs(deliveries),
            recipient: groupRecipients(deliveries)
        }),
    RelationshipUpdatedWithChanges: (_entry, deliveries, t)=>t.activityLog.notif.amendmentSent({
            channelVerb: joinChannelVerbs(deliveries),
            recipient: groupRecipients(deliveries)
        }),
    AmendmentApprovalReminderCustomer: (_entry, deliveries, t)=>t.activityLog.notif.amendmentReminder({
            channel: joinChannelLabels(deliveries),
            recipient: groupRecipients(deliveries)
        }),
    BankAccountNotVerifiedReminderCustomer: (_entry, deliveries, t)=>t.activityLog.notif.bankAccountReminder({
            channel: joinChannelLabels(deliveries),
            recipient: groupRecipients(deliveries)
        }),
    RequestPaymentMethod: (_entry, deliveries, t)=>t.activityLog.notif.paymentMethodRequest({
            channelVerb: joinChannelVerbs(deliveries),
            recipient: groupRecipients(deliveries)
        }),
    InvoiceIssued: (entry, deliveries, t)=>composeWithInvoiceLink(entry, (invoiceLink)=>anyDeliveryIsApprovalRequest(deliveries) ? t.activityLog.notif.invoiceApprovalRequest({
                channelVerb: joinChannelVerbs(deliveries),
                recipient: groupRecipients(deliveries),
                invoiceLink
            }) : t.activityLog.notif.invoiceIssued({
                channelVerb: joinChannelVerbs(deliveries),
                recipient: groupRecipients(deliveries),
                invoiceLink
            })),
    PaymentFailedCustomer: (entry, deliveries, t)=>composeWithInvoiceLink(entry, (invoiceLink)=>t.activityLog.notif.paymentFailed({
                channelVerb: joinChannelVerbs(deliveries),
                recipient: groupRecipients(deliveries),
                invoiceLink
            })),
    InvoiceRefundedCustomer: (entry, deliveries, t)=>composeWithInvoiceLink(entry, (invoiceLink)=>t.activityLog.notif.refund({
                channelVerb: joinChannelVerbs(deliveries),
                recipient: groupRecipients(deliveries),
                invoiceLink
            })),
    AdHocInvoiceIssued: (entry, deliveries, t)=>composeWithInvoiceLink(entry, (invoiceLink)=>t.activityLog.notif.adHocInvoice({
                channelVerb: joinChannelVerbs(deliveries),
                recipient: groupRecipients(deliveries),
                invoiceLink
            })),
    AdHocInvoiceOverdueReminderCustomer: (_entry, deliveries, t)=>t.activityLog.notif.adHocOverdueReminder({
            channel: joinChannelLabels(deliveries),
            recipient: groupRecipients(deliveries)
        })
};
const FALLBACK_HEADLINE = (_entry, deliveries, t)=>t.activityLog.notif.fallback({
        channelVerb: joinChannelVerbs(deliveries),
        recipient: groupRecipients(deliveries)
    });
export const renderHeadline = (entry, t)=>{
    var _NOTIFICATION_HEADLINES_entry_state;
    const deliveries = entry.deliveries();
    const factory = (_NOTIFICATION_HEADLINES_entry_state = NOTIFICATION_HEADLINES[entry.state()]) !== null && _NOTIFICATION_HEADLINES_entry_state !== void 0 ? _NOTIFICATION_HEADLINES_entry_state : FALLBACK_HEADLINE;
    return factory(entry, deliveries, t);
};
